export default "__VITE_ASSET__C_GZcMV8__"